module.exports = __webpack_public_path__ + "img/logocybersiapSinTexto.50e3377a.jpg";